import 'normalize.css';
import React from 'react';
import { render } from 'react-dom';
import App from './containers/app';
import registerServiceWorker from './registerServiceWorker';
import './styles/index.css';

const target = document.getElementById('root');

render(
  <App />,
  target
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js